import SensorsTable from './SensorsTable';
export default SensorsTable;
